/* ============================================================
   RootFix Listicle Landing — mini-quiz overlay + slider + stepper
   No frameworks. Vanilla JS IIFE.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('rootfix-landing-root');
  if (!root) return;

  // ============================================================
  // Lazy-load videos — only load & play when scrolled into view
  // ============================================================
  if ('IntersectionObserver' in window) {
    var lazyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;

        // Load and play videos when scrolled into view
        if (el.tagName === 'VIDEO') {
          el.preload = 'auto';
          el.load();
          el.play().catch(function () {
            document.addEventListener('touchstart', function retry() {
              el.play().catch(function () {});
              document.removeEventListener('touchstart', retry);
            }, { once: true });
          });
        }

        // Lazy images (GIFs etc.)
        if (el.tagName === 'IMG' && el.dataset.src) {
          el.src = el.dataset.src;
        }

        lazyObserver.unobserve(el);
      });
    }, { rootMargin: '300px' });

    root.querySelectorAll('.rl-lazy-video, .rl-lazy-img').forEach(function (el) {
      lazyObserver.observe(el);
    });
  } else {
    root.querySelectorAll('.rl-lazy-video').forEach(function (v) {
      v.preload = 'auto'; v.load(); v.play().catch(function () {});
    });
    root.querySelectorAll('.rl-lazy-img').forEach(function (img) {
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }

  var PRODUCT_URL  = root.dataset.productUrl  || '/products/rootfix-kit';
  var DISCOUNT     = root.dataset.discountCode || 'PES50';
  var FINAL_URL    = '/discount/' + DISCOUNT + '?redirect=' + encodeURIComponent(PRODUCT_URL);

  // Reuse the area images that already exist on the Quiz page (Shopify Files CDN)
  var AREA_IMAGES = {
    temples: 'https://cdn.shopify.com/s/files/1/0790/4201/9580/files/Untitled_design_24.png?v=1775876223',
    front:   'https://cdn.shopify.com/s/files/1/0790/4201/9580/files/Untitled_design_25.png?v=1775876226',
    crown:   'https://cdn.shopify.com/s/files/1/0790/4201/9580/files/Untitled_design_26.png?v=1775876228',
    diffuse: 'https://cdn.shopify.com/s/files/1/0790/4201/9580/files/Untitled_design_27.png?v=1775876229',
    unknown: 'https://cdn.shopify.com/s/files/1/0790/4201/9580/files/Untitled_design_28.png?v=1775876229',
  };

  var AREA_OPTIONS = [
    { id: 'temples', label: 'מפרצים / קו השיער הקדמי', img: AREA_IMAGES.temples },
    { id: 'front',   label: 'קדמת הראש',                img: AREA_IMAGES.front   },
    { id: 'crown',   label: 'מרכז וכתר הראש',           img: AREA_IMAGES.crown   },
    { id: 'diffuse', label: 'דלילות כללית',             img: AREA_IMAGES.diffuse },
    { id: 'unknown', label: 'אני לא בטוח',               img: AREA_IMAGES.unknown },
  ];

  // ----------- Analytics helper -----------
  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, data || {}));
    } catch (e) {}
  }

  // ============================================================
  // Mini-quiz state machine
  // ============================================================
  var modal     = document.getElementById('rl-modal');
  var modalBody = document.getElementById('rl-modal-body');
  var progress  = document.getElementById('rl-progress');

  var STEP_PROGRESS = { areas: 33, stillHair: 66, analyzing: 90, result: 100 };

  var state = {
    step: 'areas',
    areas: [],
    stillHair: null,
  };

  var _scrollY = 0;

  function openQuiz() {
    state.step = 'areas';
    state.areas = [];
    state.stillHair = null;
    _scrollY = window.scrollY || window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.width = '100%';
    modal.hidden = false;
    render();
    track('rl_quiz_open');
  }

  function closeQuiz() {
    if (state._autoRedirect) { clearTimeout(state._autoRedirect); state._autoRedirect = null; }
    modal.hidden = true;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
    track('rl_quiz_close', { step: state.step });
  }

  function setStep(step) {
    state.step = step;
    render();
    track('rl_quiz_step', { step: step });
  }

  function render() {
    progress.style.width = (STEP_PROGRESS[state.step] || 33) + '%';
    modalBody.innerHTML = '';
    if (state.step === 'areas')        renderAreas();
    else if (state.step === 'stillHair') renderStillHair();
    else if (state.step === 'analyzing') renderAnalyzing();
    else if (state.step === 'result')    renderResult();
  }

  // ----------- Step 1: Where are you losing hair -----------
  function renderAreas() {
    var wrap = el('div', 'rl-mq-step');
    wrap.appendChild(el('div', 'rl-mq-eyebrow', 'שלב 1 מתוך 3'));
    wrap.appendChild(el('h3', 'rl-mq-title', 'איפה אתה שם לב לדלילות או נשירה?'));
    wrap.appendChild(el('p',  'rl-mq-sub', 'בחר אזור אחד'));

    var grid = el('div', 'rl-mq-grid');
    AREA_OPTIONS.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rl-mq-opt';

      var img = document.createElement('img');
      img.className = 'rl-mq-opt-img';
      img.src = opt.img;
      img.alt = opt.label;
      img.width = 90;
      img.height = 90;
      img.loading = 'lazy';
      img.decoding = 'async';
      btn.appendChild(img);

      btn.appendChild(el('div', 'rl-mq-opt-label', opt.label));

      btn.addEventListener('click', function () {
        state.areas = [opt.id];
        track('rl_quiz_areas', { areas: state.areas });
        setStep('stillHair');
      });
      grid.appendChild(btn);
    });
    wrap.appendChild(grid);

    modalBody.appendChild(wrap);
  }

  // ----------- Step 2: Do you still have hair in those areas? -----------
  function renderStillHair() {
    var wrap = el('div', 'rl-mq-step');
    wrap.appendChild(el('div', 'rl-mq-eyebrow', 'שלב 2 מתוך 3'));
    wrap.appendChild(el('h3', 'rl-mq-title', 'האם עדיין יש לך שיער באזורים הדלילים?'));
    wrap.appendChild(el('p',  'rl-mq-sub', 'גם שיער דק או קצר נחשב — חשוב לדעת אם הזקיקים עוד פעילים'));

    var grid = el('div', 'rl-mq-yesno');

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'rl-mq-yesno-btn';
    yes.appendChild(el('span', 'rl-mq-yesno-icon', '✅'));
    yes.appendChild(document.createTextNode('כן'));
    yes.addEventListener('click', function () {
      state.stillHair = 'yes';
      track('rl_quiz_stillhair', { answer: 'yes' });
      setStep('analyzing');
    });

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'rl-mq-yesno-btn';
    no.appendChild(el('span', 'rl-mq-yesno-icon', '🤔'));
    no.appendChild(document.createTextNode('לא בטוח'));
    no.addEventListener('click', function () {
      state.stillHair = 'no';
      track('rl_quiz_stillhair', { answer: 'no' });
      setStep('analyzing');
    });

    grid.appendChild(yes);
    grid.appendChild(no);
    wrap.appendChild(grid);

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'rl-mq-back';
    back.textContent = '← חזרה';
    back.addEventListener('click', function () { setStep('areas'); });
    wrap.appendChild(back);

    modalBody.appendChild(wrap);
  }

  // ----------- Prefetch product page in background -----------
  var _prefetched = false;
  function prefetchProduct() {
    if (_prefetched) return;
    _prefetched = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = PRODUCT_URL;
    document.head.appendChild(link);
  }

  // ----------- Step 3: Fake analyzing animation -----------
  function renderAnalyzing() {
    // Start prefetching while user waits — page will be cached when they click
    prefetchProduct();

    var wrap = el('div', 'rl-mq-step rl-mq-loading');
    wrap.appendChild(el('div', 'rl-mq-loading-spinner'));
    var text = el('p', 'rl-mq-loading-text', 'מנתחים את התשובות שלך...');
    wrap.appendChild(text);
    wrap.appendChild(el('p', 'rl-mq-loading-sub', 'בודקים אם RootFix מתאים למצב שלך'));
    modalBody.appendChild(wrap);

    var messages = [
      'בודקים את אזורי הדלילות...',
      'מצאנו התאמה ✓',
    ];
    var i = 0;
    var interval = setInterval(function () {
      i++;
      if (i < messages.length) {
        text.textContent = messages[i];
      } else {
        clearInterval(interval);
        setStep('result');
      }
    }, 450);
  }

  // ----------- Step 4: Qualifying result -----------
  function renderResult() {
    var wrap = el('div', 'rl-mq-step rl-mq-result');

    var badge = el('div', 'rl-mq-result-badge');
    badge.appendChild(document.createTextNode('✓ נמצאה התאמה'));
    wrap.appendChild(badge);

    wrap.appendChild(el('h3', 'rl-mq-result-title', 'אתה מתאים לטיפול של RootFix'));

    var text = document.createElement('p');
    text.className = 'rl-mq-result-text';
    text.innerHTML = 'על פי התשובות שלך, הזקיקים שלך עדיין <strong>פעילים מספיק</strong> ' +
                     'כדי להגיב לטיפול. RootFix מתאים בדיוק למצב שלך — ' +
                     'במיוחד כי בחרת אזורים שעדיין ניתנים להעיר.';
    wrap.appendChild(text);

    var urgency = el('div', 'rl-mq-result-urgency');
    urgency.innerHTML = '<strong>⚠️ חשוב:</strong> הזקיקים לא מחכים. ככל שמתחילים מוקדם יותר, ' +
                        'הסיכוי לתוצאות טובות גבוה משמעותית. כל חודש שעובר — יותר זקיקים נכנסים לשינה.';
    wrap.appendChild(urgency);

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'rl-cta rl-cta-big';
    cta.textContent = 'התחל את הטיפול עכשיו ←';
    cta.addEventListener('click', function () {
      track('rl_quiz_complete_cta', { areas: state.areas, stillHair: state.stillHair });
      window.location.href = FINAL_URL;
    });
    wrap.appendChild(cta);

    var micro = el('p', 'rl-cta-micro', '🛡 120 יום אחריות · 🚚 משלוח חינם · 🏠 תהליך קצר בבית');
    wrap.appendChild(micro);

    modalBody.appendChild(wrap);

    // Auto-redirect after 7 seconds if user doesn't click
    state._autoRedirect = setTimeout(function () {
      track('rl_quiz_auto_redirect', { areas: state.areas, stillHair: state.stillHair });
      window.location.href = FINAL_URL;
    }, 7000);
  }

  // ============================================================
  // Helpers
  // ============================================================
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  // ============================================================
  // Results Slider (Reason 4)
  // ============================================================
  var slider = document.getElementById('rl-results-slider');
  if (slider) {
    var sliderTrack = slider.querySelector('.rl-slider-track');
    var slides      = slider.querySelectorAll('.rl-slider-slide');
    var prevBtn     = slider.querySelector('.rl-slider-prev');
    var nextBtn     = slider.querySelector('.rl-slider-next');
    var dotsWrap    = document.getElementById('rl-slider-dots');
    var total       = slides.length;
    var currentSlide = 0;
    var isDragging   = false;
    var startX       = 0;
    var currentX     = 0;
    var dragOffset   = 0;

    function getSlidesVisible() {
      return window.innerWidth <= 640 ? 1 : 3;
    }

    function getSlideWidthPct() {
      return window.innerWidth <= 640 ? 82 : 33.333;
    }

    function getMaxSlide() {
      return Math.max(0, total - (window.innerWidth <= 640 ? 1 : 3));
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= getMaxSlide(); i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rl-slider-dot';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        if (i === currentSlide) dot.classList.add('is-active');
        dot.dataset.index = i;
        dot.addEventListener('click', function () {
          goTo(parseInt(this.dataset.index));
        });
        dotsWrap.appendChild(dot);
      }
    }

    function updateSlider(extraPx) {
      var widthPct = getSlideWidthPct();
      var pct = widthPct * currentSlide;
      var extra = extraPx || 0;
      // RTL: positive translateX
      sliderTrack.style.transform = 'translateX(calc(' + pct + '% + ' + extra + 'px))';

      var dots = dotsWrap.querySelectorAll('.rl-slider-dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentSlide);
      });

      slides.forEach(function (s) {
        s.style.flex = '0 0 ' + widthPct + '%';
      });
    }

    function goTo(index) {
      sliderTrack.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      currentSlide = Math.max(0, Math.min(index, getMaxSlide()));
      updateSlider();
    }

    prevBtn.addEventListener('click', function () { goTo(currentSlide + 1); });
    nextBtn.addEventListener('click', function () { goTo(currentSlide - 1); });

    // Touch/drag support — cache width to avoid forced reflow
    var cachedSliderWidth = slider.offsetWidth;
    window.addEventListener('resize', function () { cachedSliderWidth = slider.offsetWidth; });

    function onPointerDown(e) {
      isDragging = true;
      cachedSliderWidth = slider.offsetWidth;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      currentX = startX;
      dragOffset = 0;
      sliderTrack.style.transition = 'none';
    }
    function onPointerMove(e) {
      if (!isDragging) return;
      currentX = e.touches ? e.touches[0].clientX : e.clientX;
      dragOffset = currentX - startX;
      updateSlider(dragOffset);
    }
    function onPointerEnd() {
      if (!isDragging) return;
      isDragging = false;
      var threshold = cachedSliderWidth * 0.15;
      // RTL: positive drag = next, negative = prev
      if (dragOffset > threshold) {
        goTo(currentSlide + 1);
      } else if (dragOffset < -threshold) {
        goTo(currentSlide - 1);
      } else {
        goTo(currentSlide);
      }
      dragOffset = 0;
    }

    slider.addEventListener('touchstart', onPointerDown, { passive: true });
    slider.addEventListener('touchmove', onPointerMove, { passive: true });
    slider.addEventListener('touchend', onPointerEnd);
    slider.addEventListener('mousedown', onPointerDown);
    slider.addEventListener('mousemove', onPointerMove);
    slider.addEventListener('mouseup', onPointerEnd);
    slider.addEventListener('mouseleave', function () {
      if (isDragging) onPointerEnd();
    });

    // Prevent image dragging
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img) img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    window.addEventListener('resize', function () {
      buildDots();
      goTo(Math.min(currentSlide, getMaxSlide()));
    });

    buildDots();
    updateSlider();
  }

  // ============================================================
  // Horizontal Stepper (Reason 2 Timeline)
  // ============================================================
  var stepper = document.getElementById('rl-stepper');
  if (stepper) {
    var dots = stepper.querySelectorAll('.rl-stepper-dot');
    var panels = stepper.querySelectorAll('.rl-stepper-panel');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.step);

        // Update dots
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Update panels
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var target = stepper.querySelector('[data-panel="' + idx + '"]');
        if (target) target.classList.add('is-active');
      });
    });
  }

  // ============================================================
  // Sticky CTA — show during reasons, hide at top & bottom
  // ============================================================
  var sticky = document.getElementById('rl-sticky');
  if (sticky) {
    var dhtSection = root.querySelector('.rl-section');
    var productSection = root.querySelector('.rl-product');

    function updateSticky() {
      if (!dhtSection) return;
      var firstTop = dhtSection.getBoundingClientRect().top;
      var productTop = productSection ? productSection.getBoundingClientRect().top : Infinity;
      var viewH = window.innerHeight;

      // Show when first reason is scrolled into view, hide when product section enters
      var show = firstTop < viewH * 0.7 && productTop > viewH * 0.5;
      sticky.classList.toggle('is-visible', show);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }

  // ============================================================
  // Product Image Slider
  // ============================================================
  var prodSlider = document.getElementById('rl-prod-slider');
  if (prodSlider) {
    var prodTrack = prodSlider.querySelector('.rl-prod-slider-track');
    var prodSlides = prodSlider.querySelectorAll('.rl-prod-slide');
    var prodDotsWrap = document.getElementById('rl-prod-dots');
    var prodCurrent = 0;
    var prodTotal = prodSlides.length;
    var prodDragging = false;
    var prodStartX = 0;
    var prodDragOffset = 0;

    function buildProdDots() {
      prodDotsWrap.innerHTML = '';
      for (var i = 0; i < prodTotal; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'rl-prod-dot' + (i === prodCurrent ? ' is-active' : '');
        d.dataset.idx = i;
        d.addEventListener('click', function () { goToProd(parseInt(this.dataset.idx)); });
        prodDotsWrap.appendChild(d);
      }
    }

    function updateProd(extra) {
      var pct = 100 * prodCurrent;
      var ex = extra || 0;
      prodTrack.style.transform = 'translateX(calc(' + pct + '% + ' + ex + 'px))';
      var dots = prodDotsWrap.querySelectorAll('.rl-prod-dot');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === prodCurrent); });
    }

    function goToProd(idx) {
      prodTrack.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      prodCurrent = Math.max(0, Math.min(idx, prodTotal - 1));
      updateProd();
    }

    // Touch/drag
    prodSlider.addEventListener('touchstart', function (e) {
      prodDragging = true;
      prodStartX = e.touches[0].clientX;
      prodDragOffset = 0;
      prodTrack.style.transition = 'none';
    }, { passive: true });
    prodSlider.addEventListener('touchmove', function (e) {
      if (!prodDragging) return;
      prodDragOffset = e.touches[0].clientX - prodStartX;
      updateProd(prodDragOffset);
    }, { passive: true });
    prodSlider.addEventListener('touchend', function () {
      if (!prodDragging) return;
      prodDragging = false;
      var threshold = prodSlider.offsetWidth * 0.2;
      if (prodDragOffset > threshold) goToProd(prodCurrent + 1);
      else if (prodDragOffset < -threshold) goToProd(prodCurrent - 1);
      else goToProd(prodCurrent);
      prodDragOffset = 0;
    });

    // Prevent image drag
    prodSlides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img) img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    buildProdDots();
    updateProd();
  }

  // ============================================================
  // Highlight animation on product description
  // ============================================================
  var prodDesc = document.getElementById('rl-prod-desc');
  if (prodDesc && 'IntersectionObserver' in window) {
    var hlObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var highlights = prodDesc.querySelectorAll('.rl-highlight');
          highlights.forEach(function (hl, i) {
            setTimeout(function () { hl.classList.add('is-visible'); }, i * 250);
          });
          hlObserver.unobserve(prodDesc);
        }
      });
    }, { threshold: 0.3 });
    hlObserver.observe(prodDesc);
  }

  // ============================================================
  // Wire up triggers
  // ============================================================
  document.querySelectorAll('[data-rl-open-quiz]').forEach(function (btn) {
    btn.addEventListener('click', openQuiz);
  });
  document.querySelectorAll('[data-rl-close]').forEach(function (btn) {
    btn.addEventListener('click', closeQuiz);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeQuiz();
  });
})();
